import axios from 'axios';
// import store from "@/store";
import qs from 'qs';
import {message} from 'antd';
import {API_URL, FRESH_API_URL, SESSION_URL, KQMS_API_URL} from './apiUrl';
import {storage} from '../config/storage';
import {TIMEOUT} from '../../utils/constants';
import {logoutApp} from 'store/global/actions';
import store from '../../store';

const apiKey = process.env.REACT_APP_API_KEY;
let cancelTokenSource = axios.CancelToken.source();
const renewCancelToken = () => (cancelTokenSource = axios.CancelToken.source());
const verifyUserPath = 'user/verify';
export const abortAllApiCalls = () =>
    cancelTokenSource.cancel('Aborting calls...');
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 501) {
            error?.response?.data?.message &&
                message.error(error?.response?.data?.message, TIMEOUT);
            store.dispatch(logoutApp());
        } else {
            if (axios.isCancel(error)) console.log(error.message);
            else if (error?.response?.config?.url.includes('getBBModel')) {
                console.log(error);
            } else {
                message.error(error?.response?.data?.message, TIMEOUT);
            }
        }
        return false;
    },
);
export const _authorizationHeaders = async (isAddSession = true) => {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
        api_key: apiKey,
    };
    if (isAddSession) {
        headers.loggedInUID =
            Number(storage?.fetch.userDetails()?.userId) || -1;
        headers.session = storage?.fetch.session() || '';
        let sessionId = storage?.fetch.userDetails()?.sessionId || '';
        let sessionExpiration = storage?.fetch.sessionExpiry() || '';
        let now = new Date();
        let expiryDate = new Date(sessionExpiration);
        if (
            (sessionId && headers.session === '') ||
            now.getTime() >= expiryDate.getTime()
        ) {
            try {
                let resp = await axios({
                    method: 'post',
                    url: SESSION_URL,
                    headers: {},
                    data: {
                        sessionId: storage?.fetch.userDetails()?.sessionId,
                    },
                });
                storage.set.session(resp.data.session);
                storage.set.sessionExpiry(resp.data.sessionExpiration);
                headers.session = resp.data.session;
            } catch (err) {
                handleError(err);
            }
        }
    }
    return headers;
};

export const _authorizationKqmsImageHeaders = async (isAddSession = true) => {
    const headers = {
        'Content-Type': 'image/png',
        Accept: '*/*',
        api_key: apiKey,
    };
    if (isAddSession) {
        headers.loggedInUID =
            Number(storage?.fetch.userDetails()?.userId) || -1;
        headers.session = storage?.fetch.session() || '';
        let sessionId = storage?.fetch.userDetails()?.sessionId || '';
        let sessionExpiration = storage?.fetch.sessionExpiry() || '';
        let now = new Date();
        let expiryDate = new Date(sessionExpiration);
        if (
            (sessionId && headers.session === '') ||
            now.getTime() >= expiryDate.getTime()
        ) {
            let resp = await axios({
                method: 'post',
                url: SESSION_URL,
                headers: {},
                data: {
                    sessionId: storage?.fetch.userDetails()?.sessionId,
                },
            });
            storage.set.session(resp.data.session);
            storage.set.sessionExpiry(resp.data.sessionExpiration);
            headers.session = resp.data.session;
        }
    }
    return headers;
};

const handleError = (err) => {
    err?.response?.data?.message &&
        message.error(err?.response?.data?.message, TIMEOUT);
    console.log(`Api call error in services -> request.js : `, err);
};

export const getRequest = async (url, opt = {}) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) ? false : true,
    );
    try {
        const res = await axios.get(
            (opt?.apiUrl === 'fresh' ? FRESH_API_URL : API_URL) + url,
            {
                headers: Object.assign({}, headers),
                data: {},
                responseType: opt?.resType ? opt.resType : 'arraybuffer',
                cancelToken: opt?.cancelToken ?? cancelTokenSource.token,
            },
        );
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        if (!url.includes('getBBModel')) {
            handleError(err);
        }
    }
};

export const getKQMSRequest = async (url, opt = {}) => {
    const headers = await _authorizationHeaders(
        url.includes('verifyUser') ? false : true,
    );
    try {
        const res = await axios.get(KQMS_API_URL + url, {
            headers: {
                ...headers,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: {},
            cancelToken: cancelTokenSource.token,
        });
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const getKQMSImageRequest = async (url, opt = {}) => {
    const headers = await _authorizationKqmsImageHeaders(
        url.includes('verifyUser') ? false : true,
    );
    try {
        const res = await axios.get(KQMS_API_URL + url, {
            headers: {
                ...headers,
                'Content-Type': 'image/png',
            },
            data: {},
            cancelToken: cancelTokenSource.token,
        });
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const getListRequest = async (url) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) ? false : true,
    );
    try {
        const res = await axios.get(API_URL + url, {
            headers: {
                ...headers,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: {},
            cancelToken: cancelTokenSource.token,
        });
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};
function verifyLogin(url) {
    return (
        window?.location?.pathname === '/login' && url.includes('verifyLogin')
    );
}

export const postRequest = async (url, data = {}, opt = {}) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) || verifyLogin(url) ? false : true,
    );
    let headerTempObj = {};
    let data1 = qs.stringify(data);
    if (
        url.includes('registerUser') ||
        url.includes('updateDisclaimer') ||
        url.includes('updateUserPortfolio') ||
        url.includes('getSignalList') ||
        url.includes('getSignalData') ||
        url.includes('setSignalReview') ||
        url.includes('setUserProps') ||
        url.includes('editUser') ||
        url.includes('searchEntity') ||
        url.includes('getShortlistingEntityInfo') ||
        url.includes('companyList') ||
        url.includes('addRegistration') ||
        url.includes('getEntitySignal') ||
        url.includes('updateUserPortDetails') ||
        url.includes('updateCompanyDisclaimer') ||
        url.includes('getLeadAnalystList') ||
        url.includes('addSignalReviewPost') ||
        url.includes('registerNewUser') ||
        url.includes('getPortList')
    ) {
        headerTempObj = {'Content-Type': 'application/json'};
        data1 = data;
    }
    if (url.includes('saveS3Files')) {
        headerTempObj = {'Content-Type': 'multipart/form-data'};
        data1 = data;
    }
    try {
        const res = await axios({
            url: API_URL + url,
            method: 'POST',
            headers: {...headers, ...headerTempObj},
            data: data1,
            httpsAgent: {
                rejectUnauthorized: false,
            },
            cancelToken:
                opt.bypassToken || opt.renewToken
                    ? null
                    : cancelTokenSource.token,
        });
        if (opt.renewToken) {
            renewCancelToken();
        }
        // console.log({res})

        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const postRequestFreshChat = async (url, data = {}) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) || verifyLogin(url) ? false : true,
    );
    let headerTempObj = {};
    let data1 = qs.stringify(data);
    if (
        url.includes('registerUser') ||
        url.includes('updateDisclaimer') ||
        url.includes('updateUserPortfolio') ||
        url.includes('getSignalList') ||
        url.includes('getSignalData') ||
        url.includes('setSignalReview') ||
        url.includes('setUserProps') ||
        url.includes('editUser')
    ) {
        headerTempObj = {'Content-Type': 'application/json'};
        data1 = data;
    }
    if (url.includes('saveS3Files')) {
        headerTempObj = {'Content-Type': 'multipart/form-data'};
        data1 = data;
    }
    // console.log(FRESH_API_URL + url)
    try {
        const res = await axios({
            url: FRESH_API_URL + url,
            method: 'POST',
            headers: {...headers, ...headerTempObj},
            data: data1,
            httpsAgent: {
                rejectUnauthorized: false,
            },
            cancelToken: cancelTokenSource.token,
        });
        // console.log({res})
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const postRequestDirect = async (url, data = {}, header) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) ? false : true,
    );
    try {
        if (
            url.includes('deletePortfolio') ||
            url.includes('addUser') ||
            url.includes('updateUser')
        ) {
            headers['Content-Type'] = 'application/json';
        }
        const res = await axios({
            url: API_URL + url,
            method: 'POST',
            headers: {...headers, ...header},
            data: data,
            httpsAgent: {
                rejectUnauthorized: false,
            },
        });

        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const postRequestTemp = async (url, data = {}) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) ? false : true,
    );
    try {
        const res = await axios({
            url: API_URL + url + '?' + qs.stringify(data),
            method: 'POST',
            headers: {...headers, 'Content-Type': 'application/json'},
            data: data,
            httpsAgent: {
                rejectUnauthorized: false,
            },
            cancelToken: cancelTokenSource.token,
        });
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const putRequest = async (url, data = {}) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) ? false : true,
    );
    try {
        const res = await axios({
            url: API_URL + url,
            method: 'PUT',
            headers: Object.assign({}, headers),
            data,
            cancelToken: cancelTokenSource.token,
        });
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const patchRequest = async (url, data = {}) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) ? false : true,
    );
    try {
        const res = await axios({
            url: API_URL + url,
            method: 'PATCH',
            headers: Object.assign({}, headers),
            body: JSON.stringify(data),
            cancelToken: cancelTokenSource.token,
        });
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const deleteRequest = async (url) => {
    const headers = await _authorizationHeaders(
        url.includes(verifyUserPath) ? false : true,
    );
    try {
        const res = await axios({
            url: API_URL + url,
            method: 'DELETE',
            headers: Object.assign({}, headers),
            cancelToken: cancelTokenSource.token,
        });
        return res.data.result ? res.data.result : res.data;
    } catch (err) {
        handleError(err);
    }
};

export const Api = {
    deleteRequest,
    getListRequest,
    getRequest,
    getKQMSRequest,
    getKQMSImageRequest,
    postRequest,
    putRequest,
    patchRequest,
    postRequestTemp,
    postRequestDirect,
    postRequestFreshChat,
};
